"use client"
 
import { IS_GTM_ENABLED, trackingConfig } from './config';
import { Gtag } from './types';

const logGAWarning = (message: string) => {
  console.warn(`[Tracking] Warning: ${message}`)
}
 
const getGtag = () => {
  if (!IS_GTM_ENABLED) {
    logGAWarning('Google Analytics is not enabled')
    return null
  }
  if (!window.gtag) {
    logGAWarning('GTag does not exist')
    throw new Error('GTag does not exist')
  }
  return window.gtag
}
 
const withGtag = (callback: (gtag: Gtag.Gtag) => void) => {
  const gtag = getGtag()
  if (!gtag) return
  callback(gtag)
}
 
// export const sendGAEvent = (event: GtagEvent) =>
//   withGtag((gtag) => {
//     gtag('event', event.action, {
//       event_category: event.category,
//       event_label: event.label,
//       value: event.value,
//     })
//   })
 
export const grantConsentForEverything = () =>
  withGtag((gtag) => {
    gtag('consent', 'update', {
      functionality_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ad_storage: 'granted',
      analytics_storage: 'granted',
    })
  })
 
export const grantConsent = ({ functionality_storage, ad_user_data, ad_personalization, ad_storage, analytics_storage }: { functionality_storage: boolean, ad_user_data: boolean, ad_personalization: boolean, ad_storage: boolean, analytics_storage: boolean }) =>
  withGtag((gtag) => {
    gtag('consent', 'update', {
      functionality_storage: functionality_storage ? 'granted' : 'denied',
      ad_user_data: ad_user_data ? 'granted' : 'denied',
      ad_personalization: ad_personalization ? 'granted' : 'denied',
      ad_storage: ad_storage ? 'granted' : 'denied',
      analytics_storage: analytics_storage ? 'granted': 'denied',
    })
  })
 
export const markFeatureUsage = (feature: string) =>
  performance.mark('mark_feature_usage', {
    detail: { feature },
  })
 
export const pageview = (url: string) =>
  withGtag((gtag) => {
    gtag('config', trackingConfig.gtmId, {
      page_path: url,
    })
  })